// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3pg5e","title":"AfterFrontImage_title__3te_T"};